/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  isProgramError,
  type Address,
  type SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM,
  type SolanaError,
} from '@solana/kit';
import { MPL_BUBBLEGUM_PROGRAM_ADDRESS } from '../programs';

/** AssetOwnerMismatch: Asset Owner Does not match */
export const MPL_BUBBLEGUM_ERROR__ASSET_OWNER_MISMATCH = 0x1770; // 6000
/** PublicKeyMismatch: PublicKeyMismatch */
export const MPL_BUBBLEGUM_ERROR__PUBLIC_KEY_MISMATCH = 0x1771; // 6001
/** HashingMismatch: Hashing Mismatch Within Leaf Schema */
export const MPL_BUBBLEGUM_ERROR__HASHING_MISMATCH = 0x1772; // 6002
/** UnsupportedSchemaVersion: Unsupported Schema Version */
export const MPL_BUBBLEGUM_ERROR__UNSUPPORTED_SCHEMA_VERSION = 0x1773; // 6003
/** CreatorShareTotalMustBe100: Creator shares must sum to 100 */
export const MPL_BUBBLEGUM_ERROR__CREATOR_SHARE_TOTAL_MUST_BE100 = 0x1774; // 6004
/** DuplicateCreatorAddress: No duplicate creator addresses in metadata */
export const MPL_BUBBLEGUM_ERROR__DUPLICATE_CREATOR_ADDRESS = 0x1775; // 6005
/** CreatorDidNotVerify: Creator did not verify the metadata */
export const MPL_BUBBLEGUM_ERROR__CREATOR_DID_NOT_VERIFY = 0x1776; // 6006
/** CreatorNotFound: Creator not found in creator Vec */
export const MPL_BUBBLEGUM_ERROR__CREATOR_NOT_FOUND = 0x1777; // 6007
/** NoCreatorsPresent: No creators in creator Vec */
export const MPL_BUBBLEGUM_ERROR__NO_CREATORS_PRESENT = 0x1778; // 6008
/** CreatorHashMismatch: User-provided creator Vec must result in same user-provided creator hash */
export const MPL_BUBBLEGUM_ERROR__CREATOR_HASH_MISMATCH = 0x1779; // 6009
/** DataHashMismatch: User-provided metadata must result in same user-provided data hash */
export const MPL_BUBBLEGUM_ERROR__DATA_HASH_MISMATCH = 0x177a; // 6010
/** CreatorsTooLong: Creators list too long */
export const MPL_BUBBLEGUM_ERROR__CREATORS_TOO_LONG = 0x177b; // 6011
/** MetadataNameTooLong: Name in metadata is too long */
export const MPL_BUBBLEGUM_ERROR__METADATA_NAME_TOO_LONG = 0x177c; // 6012
/** MetadataSymbolTooLong: Symbol in metadata is too long */
export const MPL_BUBBLEGUM_ERROR__METADATA_SYMBOL_TOO_LONG = 0x177d; // 6013
/** MetadataUriTooLong: Uri in metadata is too long */
export const MPL_BUBBLEGUM_ERROR__METADATA_URI_TOO_LONG = 0x177e; // 6014
/** MetadataBasisPointsTooHigh: Basis points in metadata cannot exceed 10000 */
export const MPL_BUBBLEGUM_ERROR__METADATA_BASIS_POINTS_TOO_HIGH = 0x177f; // 6015
/** TreeAuthorityIncorrect: Tree creator or tree delegate must sign. */
export const MPL_BUBBLEGUM_ERROR__TREE_AUTHORITY_INCORRECT = 0x1780; // 6016
/** InsufficientMintCapacity: Not enough unapproved mints left */
export const MPL_BUBBLEGUM_ERROR__INSUFFICIENT_MINT_CAPACITY = 0x1781; // 6017
/** NumericalOverflowError: NumericalOverflowError */
export const MPL_BUBBLEGUM_ERROR__NUMERICAL_OVERFLOW_ERROR = 0x1782; // 6018
/** IncorrectOwner: Incorrect account owner */
export const MPL_BUBBLEGUM_ERROR__INCORRECT_OWNER = 0x1783; // 6019
/** CollectionCannotBeVerifiedInThisInstruction: Cannot Verify Collection in this Instruction */
export const MPL_BUBBLEGUM_ERROR__COLLECTION_CANNOT_BE_VERIFIED_IN_THIS_INSTRUCTION = 0x1784; // 6020
/** CollectionNotFound: Collection Not Found on Metadata */
export const MPL_BUBBLEGUM_ERROR__COLLECTION_NOT_FOUND = 0x1785; // 6021
/** AlreadyVerified: Collection item is already verified. */
export const MPL_BUBBLEGUM_ERROR__ALREADY_VERIFIED = 0x1786; // 6022
/** AlreadyUnverified: Collection item is already unverified. */
export const MPL_BUBBLEGUM_ERROR__ALREADY_UNVERIFIED = 0x1787; // 6023
/** UpdateAuthorityIncorrect: Incorrect leaf metadata update authority. */
export const MPL_BUBBLEGUM_ERROR__UPDATE_AUTHORITY_INCORRECT = 0x1788; // 6024
/** LeafAuthorityMustSign: This transaction must be signed by either the leaf owner or leaf delegate */
export const MPL_BUBBLEGUM_ERROR__LEAF_AUTHORITY_MUST_SIGN = 0x1789; // 6025
/** CollectionMustBeSized: Collection Not Compatable with Compression, Must be Sized */
export const MPL_BUBBLEGUM_ERROR__COLLECTION_MUST_BE_SIZED = 0x178a; // 6026
/** MetadataMintMismatch: Metadata mint does not match collection mint */
export const MPL_BUBBLEGUM_ERROR__METADATA_MINT_MISMATCH = 0x178b; // 6027
/** InvalidCollectionAuthority: Invalid collection authority */
export const MPL_BUBBLEGUM_ERROR__INVALID_COLLECTION_AUTHORITY = 0x178c; // 6028
/** InvalidDelegateRecord: Invalid delegate record pda derivation */
export const MPL_BUBBLEGUM_ERROR__INVALID_DELEGATE_RECORD = 0x178d; // 6029
/** CollectionMasterEditionAccountInvalid: Edition account doesnt match collection */
export const MPL_BUBBLEGUM_ERROR__COLLECTION_MASTER_EDITION_ACCOUNT_INVALID = 0x178e; // 6030
/** CollectionMustBeAUniqueMasterEdition: Collection Must Be a Unique Master Edition v2 */
export const MPL_BUBBLEGUM_ERROR__COLLECTION_MUST_BE_A_UNIQUE_MASTER_EDITION = 0x178f; // 6031
/** UnknownExternalError: Could not convert external error to BubblegumError */
export const MPL_BUBBLEGUM_ERROR__UNKNOWN_EXTERNAL_ERROR = 0x1790; // 6032
/** DecompressionDisabled: Decompression is disabled for this tree. */
export const MPL_BUBBLEGUM_ERROR__DECOMPRESSION_DISABLED = 0x1791; // 6033
/** MissingCollectionMintAccount: Missing collection mint account */
export const MPL_BUBBLEGUM_ERROR__MISSING_COLLECTION_MINT_ACCOUNT = 0x1792; // 6034
/** MissingCollectionMetadataAccount: Missing collection metadata account */
export const MPL_BUBBLEGUM_ERROR__MISSING_COLLECTION_METADATA_ACCOUNT = 0x1793; // 6035
/** CollectionMismatch: Collection mismatch */
export const MPL_BUBBLEGUM_ERROR__COLLECTION_MISMATCH = 0x1794; // 6036
/** MetadataImmutable: Metadata not mutable */
export const MPL_BUBBLEGUM_ERROR__METADATA_IMMUTABLE = 0x1795; // 6037
/** PrimarySaleCanOnlyBeFlippedToTrue: Can only update primary sale to true */
export const MPL_BUBBLEGUM_ERROR__PRIMARY_SALE_CAN_ONLY_BE_FLIPPED_TO_TRUE = 0x1796; // 6038
/** CreatorDidNotUnverify: Creator did not unverify the metadata */
export const MPL_BUBBLEGUM_ERROR__CREATOR_DID_NOT_UNVERIFY = 0x1797; // 6039
/** InvalidTokenStandard: Only NonFungible standard is supported */
export const MPL_BUBBLEGUM_ERROR__INVALID_TOKEN_STANDARD = 0x1798; // 6040
/** InvalidCanopySize: Canopy size should be set bigger for this tree */
export const MPL_BUBBLEGUM_ERROR__INVALID_CANOPY_SIZE = 0x1799; // 6041
/** InvalidLogWrapper: Invalid log wrapper program */
export const MPL_BUBBLEGUM_ERROR__INVALID_LOG_WRAPPER = 0x179a; // 6042
/** InvalidCompressionProgram: Invalid compression program */
export const MPL_BUBBLEGUM_ERROR__INVALID_COMPRESSION_PROGRAM = 0x179b; // 6043
/** LeafMustBeDelegated: Leaf must be delegated to someone other than the leaf owner */
export const MPL_BUBBLEGUM_ERROR__LEAF_MUST_BE_DELEGATED = 0x179c; // 6044
/** AssetIsFrozen: Asset is frozen */
export const MPL_BUBBLEGUM_ERROR__ASSET_IS_FROZEN = 0x179d; // 6045
/** AssetIsNonTransferable: Asset is non-transferable */
export const MPL_BUBBLEGUM_ERROR__ASSET_IS_NON_TRANSFERABLE = 0x179e; // 6046
/** InvalidAuthority: Invalid authority */
export const MPL_BUBBLEGUM_ERROR__INVALID_AUTHORITY = 0x179f; // 6047
/** CollectionIsFrozen: Collection is frozen */
export const MPL_BUBBLEGUM_ERROR__COLLECTION_IS_FROZEN = 0x17a0; // 6048
/** CollectionMustHaveBubblegumPlugin: Core collections must have the Bubblegum V2 plugin on them */
export const MPL_BUBBLEGUM_ERROR__COLLECTION_MUST_HAVE_BUBBLEGUM_PLUGIN = 0x17a1; // 6049
/** NotAvailable: Feature not currently available */
export const MPL_BUBBLEGUM_ERROR__NOT_AVAILABLE = 0x17a2; // 6050
/** MissingCollectionAccount: Missing collection account */
export const MPL_BUBBLEGUM_ERROR__MISSING_COLLECTION_ACCOUNT = 0x17a3; // 6051
/** AssetDataLengthTooLong: Asset data length too long */
export const MPL_BUBBLEGUM_ERROR__ASSET_DATA_LENGTH_TOO_LONG = 0x17a4; // 6052
/** AlreadyInCollection: Item is already in the collection */
export const MPL_BUBBLEGUM_ERROR__ALREADY_IN_COLLECTION = 0x17a5; // 6053
/** AlreadyNotInCollection: Item is already not in a collection */
export const MPL_BUBBLEGUM_ERROR__ALREADY_NOT_IN_COLLECTION = 0x17a6; // 6054
/** MissingMplCoreCpiSignerAccount: Missing mpl-core CPI signer account */
export const MPL_BUBBLEGUM_ERROR__MISSING_MPL_CORE_CPI_SIGNER_ACCOUNT = 0x17a7; // 6055
/** AssetIsNotFrozen: Asset is not frozen */
export const MPL_BUBBLEGUM_ERROR__ASSET_IS_NOT_FROZEN = 0x17a8; // 6056

export type MplBubblegumError =
  | typeof MPL_BUBBLEGUM_ERROR__ALREADY_IN_COLLECTION
  | typeof MPL_BUBBLEGUM_ERROR__ALREADY_NOT_IN_COLLECTION
  | typeof MPL_BUBBLEGUM_ERROR__ALREADY_UNVERIFIED
  | typeof MPL_BUBBLEGUM_ERROR__ALREADY_VERIFIED
  | typeof MPL_BUBBLEGUM_ERROR__ASSET_DATA_LENGTH_TOO_LONG
  | typeof MPL_BUBBLEGUM_ERROR__ASSET_IS_FROZEN
  | typeof MPL_BUBBLEGUM_ERROR__ASSET_IS_NON_TRANSFERABLE
  | typeof MPL_BUBBLEGUM_ERROR__ASSET_IS_NOT_FROZEN
  | typeof MPL_BUBBLEGUM_ERROR__ASSET_OWNER_MISMATCH
  | typeof MPL_BUBBLEGUM_ERROR__COLLECTION_CANNOT_BE_VERIFIED_IN_THIS_INSTRUCTION
  | typeof MPL_BUBBLEGUM_ERROR__COLLECTION_IS_FROZEN
  | typeof MPL_BUBBLEGUM_ERROR__COLLECTION_MASTER_EDITION_ACCOUNT_INVALID
  | typeof MPL_BUBBLEGUM_ERROR__COLLECTION_MISMATCH
  | typeof MPL_BUBBLEGUM_ERROR__COLLECTION_MUST_BE_A_UNIQUE_MASTER_EDITION
  | typeof MPL_BUBBLEGUM_ERROR__COLLECTION_MUST_BE_SIZED
  | typeof MPL_BUBBLEGUM_ERROR__COLLECTION_MUST_HAVE_BUBBLEGUM_PLUGIN
  | typeof MPL_BUBBLEGUM_ERROR__COLLECTION_NOT_FOUND
  | typeof MPL_BUBBLEGUM_ERROR__CREATOR_DID_NOT_UNVERIFY
  | typeof MPL_BUBBLEGUM_ERROR__CREATOR_DID_NOT_VERIFY
  | typeof MPL_BUBBLEGUM_ERROR__CREATOR_HASH_MISMATCH
  | typeof MPL_BUBBLEGUM_ERROR__CREATOR_NOT_FOUND
  | typeof MPL_BUBBLEGUM_ERROR__CREATOR_SHARE_TOTAL_MUST_BE100
  | typeof MPL_BUBBLEGUM_ERROR__CREATORS_TOO_LONG
  | typeof MPL_BUBBLEGUM_ERROR__DATA_HASH_MISMATCH
  | typeof MPL_BUBBLEGUM_ERROR__DECOMPRESSION_DISABLED
  | typeof MPL_BUBBLEGUM_ERROR__DUPLICATE_CREATOR_ADDRESS
  | typeof MPL_BUBBLEGUM_ERROR__HASHING_MISMATCH
  | typeof MPL_BUBBLEGUM_ERROR__INCORRECT_OWNER
  | typeof MPL_BUBBLEGUM_ERROR__INSUFFICIENT_MINT_CAPACITY
  | typeof MPL_BUBBLEGUM_ERROR__INVALID_AUTHORITY
  | typeof MPL_BUBBLEGUM_ERROR__INVALID_CANOPY_SIZE
  | typeof MPL_BUBBLEGUM_ERROR__INVALID_COLLECTION_AUTHORITY
  | typeof MPL_BUBBLEGUM_ERROR__INVALID_COMPRESSION_PROGRAM
  | typeof MPL_BUBBLEGUM_ERROR__INVALID_DELEGATE_RECORD
  | typeof MPL_BUBBLEGUM_ERROR__INVALID_LOG_WRAPPER
  | typeof MPL_BUBBLEGUM_ERROR__INVALID_TOKEN_STANDARD
  | typeof MPL_BUBBLEGUM_ERROR__LEAF_AUTHORITY_MUST_SIGN
  | typeof MPL_BUBBLEGUM_ERROR__LEAF_MUST_BE_DELEGATED
  | typeof MPL_BUBBLEGUM_ERROR__METADATA_BASIS_POINTS_TOO_HIGH
  | typeof MPL_BUBBLEGUM_ERROR__METADATA_IMMUTABLE
  | typeof MPL_BUBBLEGUM_ERROR__METADATA_MINT_MISMATCH
  | typeof MPL_BUBBLEGUM_ERROR__METADATA_NAME_TOO_LONG
  | typeof MPL_BUBBLEGUM_ERROR__METADATA_SYMBOL_TOO_LONG
  | typeof MPL_BUBBLEGUM_ERROR__METADATA_URI_TOO_LONG
  | typeof MPL_BUBBLEGUM_ERROR__MISSING_COLLECTION_ACCOUNT
  | typeof MPL_BUBBLEGUM_ERROR__MISSING_COLLECTION_METADATA_ACCOUNT
  | typeof MPL_BUBBLEGUM_ERROR__MISSING_COLLECTION_MINT_ACCOUNT
  | typeof MPL_BUBBLEGUM_ERROR__MISSING_MPL_CORE_CPI_SIGNER_ACCOUNT
  | typeof MPL_BUBBLEGUM_ERROR__NO_CREATORS_PRESENT
  | typeof MPL_BUBBLEGUM_ERROR__NOT_AVAILABLE
  | typeof MPL_BUBBLEGUM_ERROR__NUMERICAL_OVERFLOW_ERROR
  | typeof MPL_BUBBLEGUM_ERROR__PRIMARY_SALE_CAN_ONLY_BE_FLIPPED_TO_TRUE
  | typeof MPL_BUBBLEGUM_ERROR__PUBLIC_KEY_MISMATCH
  | typeof MPL_BUBBLEGUM_ERROR__TREE_AUTHORITY_INCORRECT
  | typeof MPL_BUBBLEGUM_ERROR__UNKNOWN_EXTERNAL_ERROR
  | typeof MPL_BUBBLEGUM_ERROR__UNSUPPORTED_SCHEMA_VERSION
  | typeof MPL_BUBBLEGUM_ERROR__UPDATE_AUTHORITY_INCORRECT;

let mplBubblegumErrorMessages: Record<MplBubblegumError, string> | undefined;
if (process.env.NODE_ENV !== 'production') {
  mplBubblegumErrorMessages = {
    [MPL_BUBBLEGUM_ERROR__ALREADY_IN_COLLECTION]: `Item is already in the collection`,
    [MPL_BUBBLEGUM_ERROR__ALREADY_NOT_IN_COLLECTION]: `Item is already not in a collection`,
    [MPL_BUBBLEGUM_ERROR__ALREADY_UNVERIFIED]: `Collection item is already unverified.`,
    [MPL_BUBBLEGUM_ERROR__ALREADY_VERIFIED]: `Collection item is already verified.`,
    [MPL_BUBBLEGUM_ERROR__ASSET_DATA_LENGTH_TOO_LONG]: `Asset data length too long`,
    [MPL_BUBBLEGUM_ERROR__ASSET_IS_FROZEN]: `Asset is frozen`,
    [MPL_BUBBLEGUM_ERROR__ASSET_IS_NON_TRANSFERABLE]: `Asset is non-transferable`,
    [MPL_BUBBLEGUM_ERROR__ASSET_IS_NOT_FROZEN]: `Asset is not frozen`,
    [MPL_BUBBLEGUM_ERROR__ASSET_OWNER_MISMATCH]: `Asset Owner Does not match`,
    [MPL_BUBBLEGUM_ERROR__COLLECTION_CANNOT_BE_VERIFIED_IN_THIS_INSTRUCTION]: `Cannot Verify Collection in this Instruction`,
    [MPL_BUBBLEGUM_ERROR__COLLECTION_IS_FROZEN]: `Collection is frozen`,
    [MPL_BUBBLEGUM_ERROR__COLLECTION_MASTER_EDITION_ACCOUNT_INVALID]: `Edition account doesnt match collection`,
    [MPL_BUBBLEGUM_ERROR__COLLECTION_MISMATCH]: `Collection mismatch`,
    [MPL_BUBBLEGUM_ERROR__COLLECTION_MUST_BE_A_UNIQUE_MASTER_EDITION]: `Collection Must Be a Unique Master Edition v2`,
    [MPL_BUBBLEGUM_ERROR__COLLECTION_MUST_BE_SIZED]: `Collection Not Compatable with Compression, Must be Sized`,
    [MPL_BUBBLEGUM_ERROR__COLLECTION_MUST_HAVE_BUBBLEGUM_PLUGIN]: `Core collections must have the Bubblegum V2 plugin on them`,
    [MPL_BUBBLEGUM_ERROR__COLLECTION_NOT_FOUND]: `Collection Not Found on Metadata`,
    [MPL_BUBBLEGUM_ERROR__CREATOR_DID_NOT_UNVERIFY]: `Creator did not unverify the metadata`,
    [MPL_BUBBLEGUM_ERROR__CREATOR_DID_NOT_VERIFY]: `Creator did not verify the metadata`,
    [MPL_BUBBLEGUM_ERROR__CREATOR_HASH_MISMATCH]: `User-provided creator Vec must result in same user-provided creator hash`,
    [MPL_BUBBLEGUM_ERROR__CREATOR_NOT_FOUND]: `Creator not found in creator Vec`,
    [MPL_BUBBLEGUM_ERROR__CREATOR_SHARE_TOTAL_MUST_BE100]: `Creator shares must sum to 100`,
    [MPL_BUBBLEGUM_ERROR__CREATORS_TOO_LONG]: `Creators list too long`,
    [MPL_BUBBLEGUM_ERROR__DATA_HASH_MISMATCH]: `User-provided metadata must result in same user-provided data hash`,
    [MPL_BUBBLEGUM_ERROR__DECOMPRESSION_DISABLED]: `Decompression is disabled for this tree.`,
    [MPL_BUBBLEGUM_ERROR__DUPLICATE_CREATOR_ADDRESS]: `No duplicate creator addresses in metadata`,
    [MPL_BUBBLEGUM_ERROR__HASHING_MISMATCH]: `Hashing Mismatch Within Leaf Schema`,
    [MPL_BUBBLEGUM_ERROR__INCORRECT_OWNER]: `Incorrect account owner`,
    [MPL_BUBBLEGUM_ERROR__INSUFFICIENT_MINT_CAPACITY]: `Not enough unapproved mints left`,
    [MPL_BUBBLEGUM_ERROR__INVALID_AUTHORITY]: `Invalid authority`,
    [MPL_BUBBLEGUM_ERROR__INVALID_CANOPY_SIZE]: `Canopy size should be set bigger for this tree`,
    [MPL_BUBBLEGUM_ERROR__INVALID_COLLECTION_AUTHORITY]: `Invalid collection authority`,
    [MPL_BUBBLEGUM_ERROR__INVALID_COMPRESSION_PROGRAM]: `Invalid compression program`,
    [MPL_BUBBLEGUM_ERROR__INVALID_DELEGATE_RECORD]: `Invalid delegate record pda derivation`,
    [MPL_BUBBLEGUM_ERROR__INVALID_LOG_WRAPPER]: `Invalid log wrapper program`,
    [MPL_BUBBLEGUM_ERROR__INVALID_TOKEN_STANDARD]: `Only NonFungible standard is supported`,
    [MPL_BUBBLEGUM_ERROR__LEAF_AUTHORITY_MUST_SIGN]: `This transaction must be signed by either the leaf owner or leaf delegate`,
    [MPL_BUBBLEGUM_ERROR__LEAF_MUST_BE_DELEGATED]: `Leaf must be delegated to someone other than the leaf owner`,
    [MPL_BUBBLEGUM_ERROR__METADATA_BASIS_POINTS_TOO_HIGH]: `Basis points in metadata cannot exceed 10000`,
    [MPL_BUBBLEGUM_ERROR__METADATA_IMMUTABLE]: `Metadata not mutable`,
    [MPL_BUBBLEGUM_ERROR__METADATA_MINT_MISMATCH]: `Metadata mint does not match collection mint`,
    [MPL_BUBBLEGUM_ERROR__METADATA_NAME_TOO_LONG]: `Name in metadata is too long`,
    [MPL_BUBBLEGUM_ERROR__METADATA_SYMBOL_TOO_LONG]: `Symbol in metadata is too long`,
    [MPL_BUBBLEGUM_ERROR__METADATA_URI_TOO_LONG]: `Uri in metadata is too long`,
    [MPL_BUBBLEGUM_ERROR__MISSING_COLLECTION_ACCOUNT]: `Missing collection account`,
    [MPL_BUBBLEGUM_ERROR__MISSING_COLLECTION_METADATA_ACCOUNT]: `Missing collection metadata account`,
    [MPL_BUBBLEGUM_ERROR__MISSING_COLLECTION_MINT_ACCOUNT]: `Missing collection mint account`,
    [MPL_BUBBLEGUM_ERROR__MISSING_MPL_CORE_CPI_SIGNER_ACCOUNT]: `Missing mpl-core CPI signer account`,
    [MPL_BUBBLEGUM_ERROR__NO_CREATORS_PRESENT]: `No creators in creator Vec`,
    [MPL_BUBBLEGUM_ERROR__NOT_AVAILABLE]: `Feature not currently available`,
    [MPL_BUBBLEGUM_ERROR__NUMERICAL_OVERFLOW_ERROR]: `NumericalOverflowError`,
    [MPL_BUBBLEGUM_ERROR__PRIMARY_SALE_CAN_ONLY_BE_FLIPPED_TO_TRUE]: `Can only update primary sale to true`,
    [MPL_BUBBLEGUM_ERROR__PUBLIC_KEY_MISMATCH]: `PublicKeyMismatch`,
    [MPL_BUBBLEGUM_ERROR__TREE_AUTHORITY_INCORRECT]: `Tree creator or tree delegate must sign.`,
    [MPL_BUBBLEGUM_ERROR__UNKNOWN_EXTERNAL_ERROR]: `Could not convert external error to BubblegumError`,
    [MPL_BUBBLEGUM_ERROR__UNSUPPORTED_SCHEMA_VERSION]: `Unsupported Schema Version`,
    [MPL_BUBBLEGUM_ERROR__UPDATE_AUTHORITY_INCORRECT]: `Incorrect leaf metadata update authority.`,
  };
}

export function getMplBubblegumErrorMessage(code: MplBubblegumError): string {
  if (process.env.NODE_ENV !== 'production') {
    return (mplBubblegumErrorMessages as Record<MplBubblegumError, string>)[
      code
    ];
  }

  return 'Error message not available in production bundles.';
}

export function isMplBubblegumError<
  TProgramErrorCode extends MplBubblegumError,
>(
  error: unknown,
  transactionMessage: {
    instructions: Record<number, { programAddress: Address }>;
  },
  code?: TProgramErrorCode
): error is SolanaError<typeof SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM> &
  Readonly<{ context: Readonly<{ code: TProgramErrorCode }> }> {
  return isProgramError<TProgramErrorCode>(
    error,
    transactionMessage,
    MPL_BUBBLEGUM_PROGRAM_ADDRESS,
    code
  );
}
